export const LanguagesMenu = [
  { title: 'Ukrainian', uniCode: 'uk', isView: true },
  { title: 'English', uniCode: 'en', isView: true }
  // { title: 'Čeština‎', uniCode: 'cs', isView: true },
  // { title: 'Polski', uniCode: 'pl', isView: true },
  // { title: 'Kazakh', uniCode: 'kz', isView: true }
];
